import type { CompletionMetricsSummary, CompletionWindowType } from 'types';

export const COMPLETION_ENDPOINT_LABEL = 'GET /api/v1/Diagnostic/Metrics/Completion';

export const COMPLETION_WINDOWS: { key: CompletionWindowType; label: string }[] = [
	{ key: 'AllTime', label: 'all_time' },
	{ key: 'Last12Months', label: 'last_12_months' },
	{ key: 'LastMonth', label: 'last_month' },
	{ key: 'LastWeek', label: 'last_week' },
	{ key: 'SinceLastSnapshot', label: 'since_last_snapshot' }
];

export type OutcomeRow = {
	code: string;
	color: string;
	label: string;
	count: (summary: CompletionMetricsSummary) => number;
	percent: (summary: CompletionMetricsSummary) => number;
};

export const OUTCOME_ROWS: OutcomeRow[] = [
	{
		code: '40',
		color: '#0b45e6',
		label: 'completed',
		count: s => s.completedCount,
		percent: s => s.completedPercent
	},
	{
		code: '10-19',
		color: '#5d7ff0',
		label: 'started_in_application',
		count: s => s.started10To19Count,
		percent: s => s.started10To19Percent
	},
	{
		code: '20-21',
		color: '#9fb0f2',
		label: 'awaiting_signatures',
		count: s => s.signing20Or21Count,
		percent: s => s.signing20Or21Percent
	},
	{
		code: '30',
		color: '#c7d0f7',
		label: 'in_processing',
		count: s => s.processing30Count,
		percent: s => s.processing30Percent
	},
	{
		code: '50',
		color: '#d4d4d8',
		label: 'canceled',
		count: s => s.canceled50Count,
		percent: s => s.canceled50Percent
	},
	{
		code: '60',
		color: '#ef9a9a',
		label: 'expired',
		count: s => s.expired60Count,
		percent: s => s.expired60Percent
	}
];

export type ChannelRow = {
	color: string;
	label: string;
	count: (summary: CompletionMetricsSummary) => number;
	percent: (summary: CompletionMetricsSummary) => number;
};

export const CHANNEL_ROWS: ChannelRow[] = [
	{
		color: '#0b45e6',
		label: 'external_web',
		count: s => s.createdViaExternalWebCount,
		percent: s => s.createdViaExternalWebPercent
	},
	{
		color: '#5d7ff0',
		label: 'employee_web',
		count: s => s.createdViaEmployeeWebCount,
		percent: s => s.createdViaEmployeeWebPercent
	},
	{
		color: '#9fb0f2',
		label: 'app',
		count: s => s.createdViaNetbankiApiCount,
		percent: s => s.createdViaNetbankiApiPercent
	}
];

export type SigningStat = {
	label: string;
	count: (summary: CompletionMetricsSummary) => number;
};

export const SIGNING_STATS: SigningStat[] = [
	{ label: 'signing_members_still_unsigned', count: s => s.signingWithUnsignedMembersCount },
	{ label: 'signing_all_members_signed', count: s => s.signingWithAllMembersSignedCount },
	{ label: 'company_signing_processes', count: s => s.companySigningCount },
	{ label: 'company_signing_members_unsigned', count: s => s.companySigningWithUnsignedMembersCount },
	{ label: 'child_portfolio_signing', count: s => s.portfolioForChildrenSigningCount },
	{
		label: 'child_portfolio_members_unsigned',
		count: s => s.portfolioForChildrenSigningWithUnsignedMembersCount
	}
];

export const MONTH_NAMES = [
	'Jan',
	'Feb',
	'Mar',
	'Apr',
	'May',
	'Jun',
	'Jul',
	'Aug',
	'Sep',
	'Oct',
	'Nov',
	'Dec'
];
